<template>
    <p>
        This is simple mode, one input at a time and real time summary results on the right, don't
        fancy it? Miss the look of a standard form? That's fine too, go to normal inputs at any time
        by clicking the arrow. You can always come back to this view by clicking the
        arrow again. We've got you covered.
        <br><br>
        To begin just press the continue button or the enter key.
        <br><br><br>
        <strong>Did you know?</strong>
        <br>
        You can use the enter and tab keys to move through the form steps &mdash; which is much quicker.
    </p>
</template>

<script>
    export default {
        name: 'intro',
    }
</script>



// WEBPACK FOOTER //
// Intro.vue?3e3eba09